<form [formGroup]="form">
  <avn-form-field [enableValidTheme]="false">
    <avn-checkbox
      formControlName="optimisticViewEnabled"
      [label]="'siteMonitoringSharedScope.SITE_MONITORING.COLUMNS_PICKER.SHOW_OPTIMISTIC_VIEW_30' | transloco"
      [avnTooltip]="'siteMonitoringSharedScope.SITE_MONITORING.OPTIMISTIC_VIEW.' + field + '.DESCRIPTION_250' | transloco"
      [tooltipPlacement]="'left'"
    ></avn-checkbox>
  </avn-form-field>
</form>
